import Button from '@atoms/Button/Button';
import Fieldset from '@atoms/Fieldset/Fieldset';
import FlashMessage from '@atoms/FlashMessage/FlashMessage';
import RadioGroup from '@atoms/Inputs/RadioGroup';
import TextInput from '@atoms/Inputs/TextInput';
import CheckboxGroup from '@molecules/CheckboxGroup/CheckboxGroup';
import HourRange from '@molecules/HourRange/HourRange';
import PagepartContent from '@molecules/PagepartContent/PagepartContent';
import useJobAlert from '@utils/useJobAlert';
import PropTypes from 'prop-types';

import styles from './JobAlert.module.scss';

function JobAlertForm({ page }) {
  const {
    inputs,
    filters,
    emailPreferences,
    handleChange,
    handleSubmit,
    formState,
  } = useJobAlert({
    ...page,
    onSuccess: () => {
      window.dataLayer.push({ event: 'jobAlertSubmit' });
    },
  });

  if (formState === 'error' || formState === 'success') {
    return (
      <>
        <h2>{page.title}</h2>
        <FlashMessage type={formState} message={page.flashMessage} />
      </>
    );
  }

  return (
    <form className={styles.cardContainer} onSubmit={handleSubmit}>
      <PagepartContent
        title={page.title}
        text={page.introText}
        extraClasses={styles.header}
      />
      <div className={styles.fieldsetContainer}>
        {filters.map(filter => (
          <Fieldset key={filter.name} legend={filter.title}>
            {filter.type === 'checkbox' && (
              // eslint-disable-next-line react/jsx-props-no-spreading
              <CheckboxGroup {...filter} />
            )}
            {filter.type === 'numberRange' && (
              <HourRange
                minHours={filter.values[0]}
                maxHours={filter.values[1]}
                onChange={filter.onChange}
              />
            )}
          </Fieldset>
        ))}

        <Fieldset legend="Wanneer wil je op de hoogte gesteld worden van een nieuwe vacature?">
          <RadioGroup
            value={inputs.emailPreference}
            name="emailPreference"
            onChange={handleChange}
            options={emailPreferences}
            required
          />
        </Fieldset>

        <Fieldset legend="Contact gegevens">
          <TextInput
            id="inputName"
            label="Wat is je naam?"
            name="name"
            required
            onChange={handleChange}
            value={inputs.name}
          />

          <TextInput
            id="inputEmail"
            label="Via welk e-mailadres wil je op de hoogte gehouden worden?"
            name="email"
            type="email"
            required
            onChange={handleChange}
            value={inputs.email}
          />
        </Fieldset>
      </div>
      <Button
        type="submit"
        label="Schrijf me in"
        extraClasses={styles.button}
        loading={formState === 'loading'}
      />
    </form>
  );
}

JobAlertForm.propTypes = {
  page: PropTypes.shape({
    title: PropTypes.string.isRequired,
    introText: PropTypes.string,
    flashMessage: PropTypes.string,
  }).isRequired,
};

export default JobAlertForm;
